import { Routes, RouterModule } from '@angular/router';
import { ParentComponent } from './parent/_pages/parent.component';
import { NgModule } from '@angular/core';

export const routes: Routes = [
  // Route for the Parent Component (starting with email verification)
  { path: 'onboarding', component: ParentComponent },
  // Default route points to the Parent Component
  { path: '', redirectTo: '/onboarding', pathMatch: 'full' },

  // Wildcard route points to the Parent Component
  { path: '**', redirectTo: '/onboarding' },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
